export default __webpack_public_path__ + "static/media/unicornEmbossLight.e4b75bb4.png";